import axios from "axios";
import { useEffect, useState } from "react";
import "./Login.css"
import Loader from "../Loader/Loader";
import url from "../../utils";


const LoginForm = ({
    validateOtp,
    setValidateOtp,
    consumerId,
    setConsumerID,
    // checkValidRationId,
    updateDetailsOtp
}) => {

    const [sendOtpLoading, setSendOtpLoading] = useState(false);
    const [validateOtpLoading, setValidateOtpLoading] = useState(false);
    const [Otp, setOtp] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");

    // state for resend otp
    const [firstOtpClick, setFirstOtpClick] = useState(false);
    const [timer, setTimer] = useState(0);
    const [canResend, setCanResend] = useState(false)

    // function for handle resend otp
    useEffect(() => {
        let interval = null;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000)
        } else {
            setCanResend(true)
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [timer])


    // handle number input
    const handleNumberInput = (e) => {
        const { value } = e.target;
        if (/^\d*$/.test(value)) {
            if (e.target.name === "consumerId")
                setConsumerID(e.target.value);
            else if (e.target.name === "mobileNumber")
                setMobileNumber(e.target.value);
            else if (e.target.name === "otp")
                setOtp(e.target.value)
        }
    }

    const checkValidCustomerId = (consumerId) => {
        let Flag = false
        if (consumerId.length < 12) {
            alert("Enter a valid consumerId")
            Flag = true;
        }

        return Flag;
    }

    const handleOtpSend = async () => {
        try {

            // if(!updateDetailsOtp&&checkValidRationId()) return;
            if (checkValidCustomerId(consumerId)) return;


            setFirstOtpClick(true)
            setSendOtpLoading(true)
            const { data } = await axios.post(
                `${url}GetOTP/Get`,
                {
                    consId: consumerId,
                    flag: "G",
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            if (data.success) {
                setValidateOtp(1);
                setMobileNumber(data.mobNo);
                // console.log
                setTimer(60);
            }
            else {
                alert(data.message)
            }
        } catch (err) {

            alert(err.response.data.message)

        } finally {
            setSendOtpLoading(false)
        }

    }

    const handleResendOtp = async () => {
        if (checkValidCustomerId(consumerId)) return;

        try {
            setSendOtpLoading(true);

            const { data } = await axios.post(
                `${url}GetOTP/Get`,
                {
                    consId: consumerId,
                    flag: "G",
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (data.success) {
                setValidateOtp(1);
                setMobileNumber(data.mobNo);
                setTimer(60);
            } else {
                alert(data.message || "Failed to send OTP");
            }

        } catch (err) {
            console.error("Error in resend OTP:", err);

            // ✅ Safe error handling
            alert(
                err?.response?.data?.message ||
                "Unable to send OTP. Please try again."
            );

        } finally {
            // ✅ Always stop loader
            setSendOtpLoading(false);
        }
    };

    // const handleValidateOtp = async () => {
    //     if (Otp.length < 6) {
    //         alert("Enter a valid OTP")
    //         return;
    //     }
    //     setValidateOtpLoading(true);

    //     const { data } = await axios.post(
    //         `${url}GetOTP/Get`,
    //         {
    //             consId: consumerId,
    //             flag: "V",
    //             otp: Otp
    //         },
    //         {
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //         }
    //     ).catch((err) => {
    //         // console.log(err.response.data)
    //         alert(err.response.data.message)
    //         setValidateOtpLoading(false)
    //         return;

    //     })

    //     // console.log("otp validate", data)
    //     setValidateOtpLoading(false)

    //     if (data.success) {
    //         alert("OTP validate successfully")
    //         setValidateOtp(2);
    //         // setOAuthToken(data.oAuthToken)
    //     } else {
    //         alert(data.statusMessage)
    //     }
    //     return () => clearInterval();
    // }


    const handleValidateOtp = async () => {
        if (Otp.length < 6) {
            alert("Enter a valid OTP");
            return;
        }

        try {
            setValidateOtpLoading(true);

            const { data } = await axios.post(
                `${url}GetOTP/Get`,
                {
                    consId: consumerId,
                    flag: "V",
                    otp: Otp
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (data.success) {
                alert("OTP validated successfully");
                setValidateOtp(2);
                // setOAuthToken(data.oAuthToken);
            } else {
                alert(data.message || "Invalid OTP");
            }

        } catch (err) {
            console.error("OTP validation error:", err);

            alert(
                err?.response?.data?.message ||
                "OTP verification failed. Please try again."
            );

        } finally {
            // ✅ Always stop loader
            setValidateOtpLoading(false);
        }
    };


    return (
        <>
            <div className="consumerId">
                <label htmlFor="">Consumer ID:</label>
                <input
                    type="text"
                    maxLength={12}
                    value={consumerId}
                    name="consumerId"
                    placeholder="Please Enter Consumer Id"
                    onChange={handleNumberInput}
                    disabled={updateDetailsOtp}
                />
            </div>
            <div className="otpValidate">
                <div className={`sendOtp ${timer > 0 ? "disabled" : ""}`}>

                    {mobileNumber !== "" &&
                        <div>
                            <p>OTP sent at *****<span>{mobileNumber.substring(5, 10)}</span></p>
                        </div>
                    }
                    <div>
                        {
                            sendOtpLoading ?
                                <Loader /> :
                                firstOtpClick ?
                                    <div className="resendOtp">
                                        <button
                                            type="button"
                                            onClick={handleResendOtp}
                                            className={`${timer > 0 && "disabled"}`}
                                            disabled={timer > 0 || sendOtpLoading}
                                        >Resend</button>
                                        {timer > 0 && <p>Time remain: {timer}</p>}
                                    </div> :
                                    <button
                                        type="button"
                                        className="otpSendButton"
                                        onClick={handleOtpSend}
                                        disabled={sendOtpLoading}
                                    >Verify ConsumerID</button>
                        }

                    </div>

                </div>
                {
                    validateOtp >= 1 &&
                    <>
                        <div className={`validateOtp ${validateOtp > 1 ? "disabled" : ""} `}>
                            <div className="enterOtp">
                                <label htmlFor="">Enter OTP:</label>
                                <input
                                    type="text"
                                    name="otp"
                                    maxLength={6}
                                    value={Otp}
                                    onChange={handleNumberInput}
                                />
                            </div>
                            {
                                validateOtpLoading ? <Loader /> :
                                    <button
                                        type="button"
                                        onClick={handleValidateOtp}
                                    // disabled={validateOtpLoading || Otp.length < 6}
                                    >Validate OTP</button>
                            }

                        </div>
                    </>

                }
            </div>

        </>
    )
};

export default LoginForm;